import * as Yup from 'yup';
import { LegalProceedingProduct } from '../../../../../../shared/types/legalProceedings/legalProceedings';

export const initialValues: LegalProceedingProduct = {
    bouquet: '',
};

export const validationSchema = Yup.object({
    bouquet: Yup.string().required('El ramo es obligatorio'),
});
